import React from 'react';

import { Colors } from '../color/Colors';

export const EDUIcon = () => {
  return (
    <div>
      <img src="/pictures/EDUIcon.svg" alt="" style={{ filter: Colors.logoFilter }} />
    </div>
  );
};
